const doubleZeroShirtNumber = 1000000; // magic value that represents shirt number 00
export default doubleZeroShirtNumber;
